// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.amountShown[data-v-73a61bf4] {\n  color: var(--main-gray-5);\n  padding-top: 4px;\n  margin: 2px 0 0 5px;\n}\n.w-link[data-v-73a61bf4]{\n  padding-top: 4px;\n  margin: 2px 0 0 5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
